module.exports = __webpack_public_path__ + "static/media/HomeHeader.7789b947.jpg";